import React, {useState, useMemo, useEffect} from 'react'
import { IPackagesItem } from '../../../../../../modules/API/Defaults/models/packages'
import SearchFromTheList from '../../../../../../generic/customSearchComponents/SearchFromTheList'

type Props = {
  list: IPackagesItem[]
  defaultID: number
  setPackageID: React.Dispatch<React.SetStateAction<number>> | ((id: number) => void)
  required?: boolean
  placeholder?: string
  disabled?: boolean
  tabIndex?: number
}

const SearchPackage = ({
  list, 
  defaultID, 
  setPackageID,
  required, 
  placeholder,
  disabled,
  tabIndex
}: Props) => {
  const defaultPackage = list.filter(item => item.PackID === defaultID)[0]
  const [isOpenDropDown, setIsOpenDropDown] = useState<boolean>(false)
  const [selectedPackage, setSelectedPackage] = useState<IPackagesItem | null>(defaultPackage || null)
  const [search, setSearch] = useState<string>(defaultPackage?.Pack_Name.trim() || '')
  const handleSearch = (e: string) => {
    if(e === '') {
      setSelectedPackage(null)
      setIsOpenDropDown(false)
      setSearch('')
      setPackageID(0)
      return
    }
    setIsOpenDropDown(true)
    setSearch(e)
  }
  const handleSelect = (item: IPackagesItem) => {
    setSearch(item.Pack_Name.trim())
    setSelectedPackage(item)
    setIsOpenDropDown(false)
    setPackageID(item.PackID)
  }
  const render = useMemo(() => {
    if(!list) return []
    return list.filter(item => 
      item.Pack_Name.trim().toLocaleLowerCase().includes(search.toLocaleLowerCase())
    )
  
  }, [search, list])
  useEffect(() => {
    if(!defaultID) return
    const found = list.find(item => item.PackID === defaultID)
    if(!found) return
    setSelectedPackage(found)
    setSearch(found.Pack_Name.trim())
  }, [defaultID])
  return (
    <SearchFromTheList 
      isOpenList={isOpenDropDown}
      placeHolder={placeholder || 'חפש סוג אריזה'}
      list={render}
      selectFunc={handleSelect}
      searchFunc={handleSearch}
      isNeedFullObject
      input={search}
      itemDisplayName='Pack_Name'
      nameIdElement='PackID'
      required={required}
      size={'full'}
      disabled={disabled}
      tabIndex={tabIndex}
      />
  )
}

export default SearchPackage